import APIService from '../api.service';

export const List = (params = {}) => {
  return APIService.get(`/v01/regions`, {
    params: {
      per_page: params.perPage ?? 100,
      page: params.page ?? 1,
      keyword: params.keyword,
      is_active: params.isActive,
    },
  });
};

export const Create = (body, config = {}) => {
  return APIService.post(`/v01/regions`, body, config);
};

export const Put = (id, body, config = {}) => {
  return APIService.put(`/v01/regions/${id}`, body, config);
};

export const Delt = (id, config = {}) => {
  return APIService.delete(`/v01/regions/${id}`, config);
};

export const All = () => {
  return APIService.get(`/v01/regions/get/all`);
};

const RegionService = {
  List,
  Create,
  Put,
  Delt,
  All,
};

export default RegionService;
